import {OptionType} from 'libs/EEC/productToEECProductType';
import {emptyByDefault, getCategory} from 'libs/EEC/productToEECProduct';
import {getName} from 'libs/EEC/getName';
import {convertPriceEEC} from 'libs/convertPrice/convertPrice';
import {findPriceWithDiscount} from 'libs/EEC/findPriceWithDiscount';
import {getVariant} from 'libs/EEC/getVariant';
import {getFrameSize} from 'libs/EEC/getFrame';
import {ProductDataType} from 'features/experiments/recommendation/types';
import {ImpressionDataType, GeneralTypeForImpressionDataType} from './prepareDataType';

const defaultOptions = {
    currencyCode: 'USD',
    category: '',
    index: 0,
};

/**
 * Prepare basic fields.
 *
 * @param {GeneralTypeForImpressionDataType} product - item product
 * @param {OptionType} options - options
 * @return {BaseImpressionDataType} - base data for impression
 */
export const prepareBaseImpressionData = (
    product: GeneralTypeForImpressionDataType,
    options: OptionType = defaultOptions,
) => ({
    name: product.parent_name || getName(product),
    id: emptyByDefault(product.product_sku || options.sku || product.sku),
    price: convertPriceEEC(findPriceWithDiscount(product)),
    category: options.category || getCategory(product),
    variant: getVariant(product, getFrameSize(product)),
});

/**
 * Prepare impression fields.
 *
 * @param {ProductDataType} products - Product list.
 * @param {EecOptionsType} options - Options.
 * @returns {Array<ImpressionDataType>} - Impression list.
 */
export const prepareImpressionData = (
    products: ProductDataType,
    options: OptionType = defaultOptions,
): ImpressionDataType => ({
    ...prepareBaseImpressionData(products, options),
    product_id: products.product_id,
    dimension36: convertPriceEEC(products.dy_display_price),
    brand: products.brand || '',
    position: 1 + (options.index || 0),
});
